import { useState } from "react";
import imageCompression from "browser-image-compression";
import img from "../assets/Spinner-3.gif";

function BgcForm() {

    const [isSameAddressChecked, setIsSameAddressChecked] = useState(false);
    const [selectExperience, setSelectExperience] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [fresher, setFresher] = useState(false);
    const [step, setStep] = useState(1);

    /* first form field */
    const [name, setName] = useState("");
    const [fname, setFname] = useState("");
    const [mname, setMname] = useState("");
    const [gender, setGender] = useState("");
    const [date, setDate] = useState("");
    const [email, setEmail] = useState("");
    const [number, setNumber] = useState("");
    const [enumber, setEnumber] = useState("");
    const [companyname, setCompanyName] = useState("Dhanlaxmi Bank Ltd");
    const [location, setLocation] = useState("");
    const [language, setLanguage] = useState("");
    const [blood, setBlood] = useState("");

    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [address3, setAddress3] = useState("");
    const [post, setPost] = useState("");
    const [police, setPolice] = useState("");
    const [district, setDistrict] = useState("");
    const [tehsil, setTehsil] = useState("");
    const [landmark, setLandmark] = useState("");
    const [pincode, setPincode] = useState("");
    const [state, setState] = useState("");

    const [address11, setAddress11] = useState("");
    const [address22, setAddress22] = useState("");
    const [address33, setAddress33] = useState("");
    const [post1, setPost1] = useState("");
    const [police1, setPolice1] = useState("");
    const [district1, setDistrict1] = useState("");
    const [tehsil1, setTehsil1] = useState("");
    const [landmark1, setLandmark1] = useState("");
    const [pincode1, setPincode1] = useState("");
    const [state1, setState1] = useState("");



     /*second form ...... */
    const [institute, setInstitute] = useState("");
    const [qualification, setQualification] = useState("");
    const [from_edu, setFrom_Edu] = useState("");
    const [grade, setGrade] = useState("");
    const [city, setCity] = useState("");
    const [graduation, setGraduation] = useState("");
    const [to_edu, setTo_Edu] = useState("");

    const [marksheet10, setMarksheet10] = useState(null);
    const [marksheet12, setMarksheet12] = useState(null);
    const [graduation_marksheet, setGraduation_Marksheet] = useState(null);
    const [provisional_degree, setProvisional_Degree] = useState(null);

    /* third form field */
    const [reference_1_name, setReference_1_Name] = useState("");
    const [reference_1_relation, setReference_1_Relation] = useState("");
    const [reference_1_address, setReference_1_Address] = useState("");
    const [reference_1_number, setReference_1_Number] = useState("");

    const [reference_2_name, setReference_2_Name] = useState("");
    const [reference_2_relation, setReference_2_Relation] = useState("");
    const [reference_2_address, setReference_2_Address] = useState("");
    const [reference_2_number, setReference_2_Number] = useState("");

  

    const [errors, setErrors] = useState({});

    /* forth form field */
    const [aadhar, setAadhar] = useState("");
    const [aadhar_front_side, setAadhar_Front_Side] = useState("");
    const [aadhar_back_side, setAadhar_Back_Side] = useState("");
    const [passport_size_photo, setPassport_Size_Photo] = useState("");
    const [pan_card, setPancard] = useState("");


    // const [other_document, setOther_Document] = useState("");
    const [candidate, setCandidateId] = useState("");

    /*Sixth form... */
    const [tenancy_number, setTenancy_Number] = useState("");
    const [house_owner_name, setHouse_Owner_Name] = useState("");
    const [tenancy_address, setTenancy_Address] = useState("");
    const [residing_date, setResiding_date] = useState("");

    const [isOwnHouse, setIsOwnHouse] = useState(false);

    const hideTenancy = () => {
        const selected = document.getElementById("tenancy1").value;
        setIsOwnHouse(selected === "Rented");
    };

    const [formValues, setFormValues] = useState([
        {
            previous_company_name: "",
            previous_designation: "",

            hr_name: "",
            Hr_number: "",
            Hr_email_id: "",

            Employee_id: "",
            previous_salary: "",

            reason_of_leaving: "",
            previous_manager: "",

            previous_manager_number: "",
            previous_manager_email_id: "",

            from_previous_company: "",
            to_previous_company: "",

            location: "",
            work_reponsibility: "",

            payslip: "",
            pay_slip2: "",
            pay_slip3: "",

            offer_letter: "",
            resignation: "",
            experience_letter: "",
        },
    ]);

    const handleChange = (index, event) => {
        const { name, value } = event.target;
        if (name === "previous_salary" && value.includes(".")) {
            setError("Values cannot be entered in the points field");
        } else {
            setError("");
        }
        const updatedFormValues = [...formValues];
        updatedFormValues[index][name] = value;
        setFormValues(updatedFormValues);
    };

    const handleFileChange1 = async (event, index, fieldName) => {
        const file = event.target.files[0];
        if (file) {
            try {
                const fileType = file.type;

                if (
                    fileType === "application/pdf" ||
                    fileType === "image/jpeg" ||
                    fileType === "image/png" ||
                    fileType === "image/jpg"
                ) {
                    let fileToSet = file;
                    if (fileType !== "application/pdf") {
                        const options = {
                            maxSizeMB: 0.2,
                            maxWidthOrHeight: 1920,
                            useWebWorker: true,
                        };
                        fileToSet = await imageCompression(file, options);
                    }
                    const updatedFormValues = [...formValues];
                    updatedFormValues[index][fieldName] = fileToSet;
                    setFormValues(updatedFormValues);
                } else {
                    console.error(
                        "Unsupported file format. Please upload a PDF, JPG, JPEG, or PNG file."
                    );
                }
            } catch (error) {
                console.error("Error processing file:", error);
            }
        }
    };

    const [error, setError] = useState("");

    const handleFileChange = async (event, setStateFunction) => {
        const file = event.target.files[0];
        if (file) {
            try {
                const fileType = file.type;

                if (
                    fileType === "application/pdf" ||
                    fileType === "image/jpeg" ||
                    fileType === "image/png" ||
                    fileType === "image/jpg"
                ) {
                    if (fileType === "application/pdf") {
                        setStateFunction(file);
                    } else {
                        const options = {
                            maxSizeMB: 0.2,
                            maxWidthOrHeight: 1920,
                            useWebWorker: true,
                        };

                        const compressedFile = await imageCompression(file, options);
                        setStateFunction(compressedFile);
                    }
                } else {
                    console.error(
                        "Unsupported file format. Please upload a PDF, JPG, JPEG, or PNG file."
                    );
                }
            } catch (error) {
                console.error("Error processing file:", error);
            }
        }
    };


    const billingFunction = () => {
        setIsSameAddressChecked((prevValue) => !prevValue);
        if (isSameAddressChecked) {
            setAddress11("");
            setAddress22("");
            setAddress33("");
            setPost1("");
            setPolice1("");
            setDistrict1("");
            setTehsil1("");
            setLandmark1("");
            setPincode1("");
            setState1("");
        } else {
            setAddress11(address1);
            setAddress22(address2);
            setAddress33(address3);
            setPost1(post);
            setPolice1(police);
            setDistrict1(district);
            setTehsil1(tehsil);
            setLandmark1(landmark);
            setPincode1(pincode);
            setState1(state);
        }
    };

    // Step headings
    const steps = ["Personal Details", "Education", "Reference", "Documents", "Tanancy", "Employement"];

    // Move to previous step
    const prevStep = () => {
        if (step > 1) setStep(step - 1);
    };
    /*first page next......... */
      const validateStep1 = () => {
        const newErrors = {};

        // Required fields validation
        if (!name) newErrors.name = "Name of the Applicant is required";
        if (!fname) newErrors.fname = "Father's Name is required";
        if (!mname) newErrors.mname = "Mother's Name is required";
        if (!gender) newErrors.gender = "Gender is required";
        if (!date) newErrors.date = "Date of Birth is required";
        if (!email) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            newErrors.email = "Invalid email format";
        }
        if (!number) {
            newErrors.number = "Contact Number is required";
        } else if (isNaN(number)) {
            newErrors.number = "Contact Number must be a number";
        }
        if (!enumber) {
            newErrors.enumber = "Emergency Contact is required";
        } else if (isNaN(enumber)) {
            newErrors.enumber = "Emergency Contact must be a number";
        }
        if (!location) newErrors.location = "Company Location is required";

        // Permanent Address validation
        if (!address1) newErrors.address1 = "Address Line 1 is required";
        if (!post) newErrors.post = "Post Office is required";
        if (!police) newErrors.police = "Police Station is required";
        if (!district) newErrors.district = "District is required";
        if (!pincode) {
            newErrors.pincode = "Pin Code is required";
        } else if (isNaN(pincode)) {
            newErrors.pincode = "Pin Code must be a number";
        }
        if (!tehsil) newErrors.tehsil = "Tehsil is required";
        if (!landmark) newErrors.landmark = "Landmark is required";
        if (!state) newErrors.state = "State is required";

        // Current Address validation
        if (!address11) newErrors.address11 = "Address Line 1 is required";
        if (!post1) newErrors.post1 = "Post Office is required";
        if (!police1) newErrors.police1 = "Police Station is required";
        if (!district1) newErrors.district1 = "District is required";
        if (!pincode1) {
            newErrors.pincode1 = "Pin Code is required";
        } else if (isNaN(pincode1)) {
            newErrors.pincode1 = "Pin Code must be a number";
        }
        if (!tehsil1) newErrors.tehsil1 = "Tehsil is required";
        if (!landmark1) newErrors.landmark1 = "Landmark is required";
        if (!state1) newErrors.state1 = "State is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

      /*Second page next......... */
    const validateStep2 = () => {
        const newErrors = {};

        // Required fields validation
        if (!institute) newErrors.institute = "Institute Name is required";
        if (!qualification) newErrors.qualification = "Qualification is required";
        if (!from_edu) newErrors.from_edu = "Date is required";
        if (!grade) newErrors.grade = "Grade is required";
        if (!city) newErrors.city = "City is required";
        if (!graduation) newErrors.graduation = "Graduation is required";
        if (!to_edu) newErrors.to_edu = "Date is required";

        if (!marksheet10) newErrors.marksheet10 = "10th Marksheet is required";
        if (!marksheet12) newErrors.marksheet12 = "12th Marksheet is required";
        if (!graduation_marksheet) newErrors.graduation_marksheet = "Graduation Marksheet is required";
        if (!provisional_degree) newErrors.provisional_degree = "Provisional Degree is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const nextStep1 = () => {
        if (validateStep1()) {
            setStep((prevStep) => prevStep + 1);
        }
        else {
            alert("Please fill out all required fields");
        }
    };

     const nextStep2 = () => {
        if (validateStep2()) {
            setStep((prevStep) => prevStep + 1);
        }
        else {
            alert("Please fill out all required fields");
        }
    };
    const nextStep3 = () => {
        const newErrors = {};
        if (!reference_1_name) newErrors.reference_1_name = "Name is required.";
        if (!reference_1_relation)
            newErrors.reference_1_relation = "Relation is required.";
        if (!reference_1_number) {
            newErrors.reference_1_number = "Contact number is required.";
        } else if (!/^\d{10}$/.test(reference_1_number)) {
            newErrors.reference_1_number = "Enter a valid 10-digit number.";
        }
        if (!reference_1_address)
            newErrors.reference_1_address = "Address is required.";

        if (!reference_2_name) newErrors.reference_2_name = "Name is required.";
        if (!reference_2_relation)
            newErrors.reference_2_relation = "Relation is required.";
        if (!reference_2_number) {
            newErrors.reference_2_number = "Contact number is required.";
        } else if (!/^\d{10}$/.test(reference_2_number)) {
            newErrors.reference_2_number = "Enter a valid 10-digit number.";
        }
        if (!reference_2_address)
            newErrors.reference_2_address = "Address is required.";

       
        // Check for duplicate numbers
        const numbers = [
            reference_1_number,
            reference_2_number,
           
        ];
        const duplicateNumbers = numbers.filter(
            (number, index) => numbers.indexOf(number) !== index
        );

        if (duplicateNumbers.length > 0) {
            newErrors.duplicate = "Duplicate contact numbers are not allowed.";
            alert("Duplicate contact numbers are not allowed.");
        }
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            setStep((prevStep) => prevStep + 1);
        }
    };

    /*Fourth page next......... */

   const validateStep4 = () => {
        const newErrors = {};

        // Required fields validation
        if (!aadhar) {
            newErrors.aadhar = "Aadhar Number is required";
        } else if (!/^\d{12}$/.test(aadhar)) {
            newErrors.aadhar = "Aadhar must be exactly 12 digits";
        }
        if (!aadhar_front_side) newErrors.aadhar_front_side = "Aadhar Front Side is required";
        if (!aadhar_back_side) newErrors.aadhar_back_side = "Aadhar Back Side is required";
        if (!passport_size_photo) newErrors.passport_size_photo = "passport Size Photo is required";
        if (!pan_card) newErrors.pan_card = "pan card is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    /*Fourth page next......... */
    const nextStep4 = () => {
        if (validateStep4()) {
            setStep((prevStep) => prevStep + 1);
        }
        else {
            alert("Please fill out all required fields");
        }
    };

    /*fifth page form.... */
    const nextStep5 = () => {

        const selectedTenancy = document.getElementById("tenancy1").value;
        if (!selectedTenancy) {
            alert("Please choose a tenancy option.");
            return;
        }
        if (selectedTenancy === "Rented") {
            if (
                !house_owner_name ||
                !tenancy_address ||
                !tenancy_number ||
                !residing_date
            ) {
                alert("Please fill out all required fields for rented tenancy.");
                return;
            }
        }
        setStep((prevStep) => prevStep + 1);
    };

    let addFormFields = () => {
        setFormValues([
            ...formValues,
            {
                previous_company_name: "",
                previous_designation: "",

                hr_name: "",
                Hr_number: "",
                Hr_email_id: "",

                Employee_id: "",
                previous_salary: "",

                reason_of_leaving: "",
                previous_manager: "",

                previous_manager_number: "",
                previous_manager_email_id: "",

                from_previous_company: "",
                to_previous_company: "",

                location: "",
                work_reponsibility: "",

                payslip: "",
                pay_slip2: "",
                pay_slip3: "",

                offer_letter: "",
                resignation: "",
                experience_letter: "",
            },
        ]);
    };

    const hideEmployment = (e) => {
        const selected = e.target.value;

        if (selected === "Experience") {
            setSelectExperience(true);
            setFresher(false);
        } else if (selected === "Fresher") {
            setSelectExperience(false);
            const confirmed = window.confirm(
                "Are You Sure You Want To Submit This Form As Fresher?"
            );
            if (confirmed) {
                setSelectExperience(false);
                setIsLoading(true);
                setFresher("fresher");
                document.querySelectorAll('input, select, textarea, button').forEach(element => {
                    element.disabled = true;
                });
                setTimeout(() => {
                    BgcFormSubmitFresher({ preventDefault: () => { } });
                }, 1000);
            } else {
                e.target.value = "";
                setSelectExperience(false);
                setFresher(false);
                setFresher(true);
                document.querySelectorAll('input, select, textarea, button').forEach(element => {
                    element.disabled = false;
                });
            }
        } else {
            setSelectExperience(false);
            setFresher(false);
            setFresher(true);
            document.querySelectorAll('input, select, textarea, button').forEach(element => {
                element.disabled = false;
            });
        }
    };

    const removeFormFields = (index) => {
        const newFormValues = [...formValues];
        newFormValues.splice(index, 1);
        setFormValues(newFormValues);
    };

    const BgcFormSubmit = async (e) => {
        setIsLoading(true);
        if (e?.preventDefault) e.preventDefault();

        if (!fresher && selectExperience) {
            // Validate required fields
            const requiredFields = [
                'previous_company_name',
                'previous_designation',
                'hr_name',
                'Hr_number',
                'Hr_email_id',
                'Employee_id',
                'previous_salary',
                'reason_of_leaving',
                'previous_manager',
                'previous_manager_number',
                'previous_manager_email_id',
                'from_previous_company',
                'to_previous_company',
                'location',
                'work_reponsibility'
            ];

            const isAnyFieldEmpty = formValues.some(form => {
                return requiredFields.some(field => {
                    const value = form[field];
                    return value === null || value === undefined || value === '';
                });
            });

            if (isAnyFieldEmpty) {
                alert("Please fill all required fields in all employment entries");
                setIsLoading(false);
                return;
            }

            const numericFields = ['Hr_number', 'previous_manager_number', 'previous_salary'];
            const hasInvalidNumber = formValues.some(form => {
                return numericFields.some(field => {
                    const value = form[field];
                    return isNaN(value) || value.toString().includes('.');
                });
            });

            if (hasInvalidNumber) {
                alert("Please enter valid whole numbers for HR number, manager number, and salary");
                setIsLoading(false);
                return;
            }

            const emailFields = ['Hr_email_id', 'previous_manager_email_id'];
            const hasInvalidEmail = formValues.some(form => {
                return emailFields.some(field => {
                    const value = form[field];
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    return !emailRegex.test(value);
                });
            });

            if (hasInvalidEmail) {
                alert("Please enter valid email addresses");
                setIsLoading(false);
                return;
            }

            const dateFields = ['from_previous_company', 'to_previous_company'];
            const hasInvalidDate = formValues.some(form => {
                return dateFields.some(field => {
                    const value = form[field];
                    return !value || isNaN(new Date(value).getTime());
                });
            });

            if (hasInvalidDate) {
                alert("Please enter valid dates in YYYY-MM-DD format");
                setIsLoading(false);
                return;
            }
        }

        const formData = new FormData();

        formData.append("full_name", name);
        formData.append("fathers_name", fname);
        formData.append("mothers_name", mname);
        formData.append("gender", gender);
        formData.append("dob", date);
        formData.append("email", email);
        formData.append("contact_number", number);
        formData.append("emergency_number", enumber);
        formData.append("name_of_the_client", companyname);
        formData.append("client_location", location);
        formData.append("language_known", language);
        formData.append("blood_group", blood);

        // Permanent Address
        formData.append("permanent_village_city", address1);
        formData.append("permanent_village_city2", address2);
        formData.append("permanent_village_city3", address3);
        formData.append("permanent_post_office", post);
        formData.append("permanent_police_station", police);
        formData.append("permanent_district", district);
        formData.append("permanent_tehsil", tehsil);
        formData.append("permanent_landmark", landmark);
        formData.append("permanent_pincode", pincode);
        formData.append("permanent_state", state);

        // Current Address
        formData.append("current_village_city", address11);
        formData.append("current_village_city2", address22);
        formData.append("current_village_city3", address33);
        formData.append("current_post_office", post1);
        formData.append("current_police_station", police1);
        formData.append("current_district", district1);
        formData.append("current_tehsil", tehsil1);
        formData.append("current_landmark", landmark1);
        formData.append("current_pincode", pincode1);
        formData.append("current_state", state1);



        formData.append("institute_name", institute);
        formData.append("qualification", qualification);
        formData.append("from_edu", from_edu);
        formData.append("to_edu", to_edu);
        formData.append("grade_edu", grade);
        formData.append("city_edu", city);
        formData.append("marksheet_10", marksheet10);
        formData.append("marksheet_12", marksheet12);
        formData.append("higher_education", graduation);
        formData.append("higher_education_marksheet", graduation_marksheet);
        formData.append("higher_education_degree_provisional", provisional_degree);

        // References
        formData.append("ref_name1", reference_1_name);
        formData.append("ref_relation1", reference_1_relation);
        formData.append("ref_contact1", reference_1_number);
        formData.append("ref_address1", reference_1_address);
        formData.append("ref_name2", reference_2_name);
        formData.append("ref_relation2", reference_2_relation);
        formData.append("ref_contact2", reference_2_number);
        formData.append("ref_address2", reference_2_address);
      

        // Documents
        formData.append("adhar_number", aadhar);
        formData.append("adhar_frontside", aadhar_front_side);
        formData.append("adhar_backside", aadhar_back_side);
        formData.append("photo", passport_size_photo);
        formData.append("pan_card", pan_card);

        // Tenancy
        formData.append("house_owner_name", house_owner_name);
        formData.append("tenancy_contact", tenancy_number);
        formData.append("address", tenancy_address);
        formData.append("residing_date", residing_date);


        if (selectExperience) {
            const employmentdata = [];

            formValues.forEach((form, index) => {
                const entry = {
                    previous_company_name: form.previous_company_name,
                    previous_designation: form.previous_designation,
                    hr_name: form.hr_name,
                    Hr_number: parseInt(form.Hr_number, 10),
                    Hr_email_id: form.Hr_email_id,
                    Employee_id: form.Employee_id,
                    previous_salary: parseInt(form.previous_salary, 10),
                    reason_of_leaving: form.reason_of_leaving,
                    previous_manager: form.previous_manager,
                    previous_manager_number: parseInt(form.previous_manager_number, 10),
                    previous_manager_email_id: form.previous_manager_email_id,
                    from_previous_company: form.from_previous_company,
                    to_previous_company: form.to_previous_company,
                    location: form.location,
                    work_reponsibility: form.work_reponsibility,
                };

                employmentdata.push(entry);

                // Append files individually (NOT inside JSON)
                const fileFields = [
                    'payslip', 'pay_slip2', 'pay_slip3',
                    'offer_letter', 'resignation',
                    'experience_letter', 'bank_statement'
                ];

                fileFields.forEach(field => {
                    const file = form[field];

                    console.log(`Checking field: ${field}, value:`, file);

                    if (file && file instanceof Blob && file.size > 0) {
                        console.log(`✅ Appending file for ${field} at index ${index}`);
                        formData.append(`employmentdata[${index}][${field}]`, file);
                    } else {
                        console.warn(`❌ Skipping ${field} at index ${index} – invalid or empty file`, file);
                    }
                });


            });

            formData.append("employmentdata", JSON.stringify(employmentdata));
            formData.append("employmentdata_count", employmentdata.length);
        }



        console.log("Submitting form data...");

        try {
            const response = await fetch("https://humhai.in/background-verification/newform/", {
                method: "POST",
                body: formData
            });

            const data = await response.json();

            console.log(data)
            setCandidateId(data.id);

            if (data.status === 200) {
                alert("Your form has been successfully submitted.");
                setIsLoading(false);
                window.location.reload();
            } else {
                alert("Something went wrong. Please try again.");
                setIsLoading(false);
            }
        } catch (error) {
            console.error("Error:", error);
            alert("There was an error submitting the form.");
            setIsLoading(false);
        } finally {
            setIsLoading(false);
            document.querySelectorAll('input, select, textarea, button').forEach(element => {
                element.disabled = false;
            });
        }
    };

    const BgcFormSubmitFresher = async (e) => {
        setIsLoading(true);
        if (e?.preventDefault) e.preventDefault();

        const formData = new FormData();

        formData.append("full_name", name);
        formData.append("fathers_name", fname);
        formData.append("mothers_name", mname);
        formData.append("gender", gender);
        formData.append("dob", date);
        formData.append("email", email);
        formData.append("contact_number", number);
        formData.append("emergency_number", enumber);
        formData.append("name_of_the_client", companyname);
        formData.append("client_location", location);
        formData.append("language_known", language);
        formData.append("blood_group", blood);

        // Permanent Address
        formData.append("permanent_village_city", address1);
        formData.append("permanent_village_city2", address2);
        formData.append("permanent_village_city3", address3);
        formData.append("permanent_post_office", post);
        formData.append("permanent_police_station", police);
        formData.append("permanent_district", district);
        formData.append("permanent_tehsil", tehsil);
        formData.append("permanent_landmark", landmark);
        formData.append("permanent_pincode", pincode);
        formData.append("permanent_state", state);

        // Current Address
        formData.append("current_village_city", address11);
        formData.append("current_village_city2", address22);
        formData.append("current_village_city3", address33);
        formData.append("current_post_office", post1);
        formData.append("current_police_station", police1);
        formData.append("current_district", district1);
        formData.append("current_tehsil", tehsil1);
        formData.append("current_landmark", landmark1);
        formData.append("current_pincode", pincode1);
        formData.append("current_state", state1);


        formData.append("institute_name", institute);
        formData.append("qualification", qualification);
        formData.append("from_edu", from_edu);
        formData.append("to_edu", to_edu);
        formData.append("grade_edu", grade);
        formData.append("city_edu", city);
        formData.append("marksheet_10", marksheet10);
        formData.append("marksheet_12", marksheet12);
        formData.append("higher_education", graduation);
        formData.append("higher_education_marksheet", graduation_marksheet);
        formData.append("higher_education_degree_provisional", provisional_degree);


        // References
        formData.append("ref_name1", reference_1_name);
        formData.append("ref_relation1", reference_1_relation);
        formData.append("ref_contact1", reference_1_number);
        formData.append("ref_address1", reference_1_address);
        formData.append("ref_name2", reference_2_name);
        formData.append("ref_relation2", reference_2_relation);
        formData.append("ref_contact2", reference_2_number);
        formData.append("ref_address2", reference_2_address);
  
        // Documents
        formData.append("adhar_number", aadhar);
        formData.append("adhar_frontside", aadhar_front_side);
        formData.append("adhar_backside", aadhar_back_side);
        formData.append("photo", passport_size_photo);
        formData.append("pan_card", pan_card);

        // Tenancy
        formData.append("house_owner_name", house_owner_name);
        formData.append("tenancy_contact", tenancy_number);
        formData.append("address", tenancy_address);
        formData.append("residing_date", residing_date);


        if (selectExperience) {
            const employmentdata = formValues.map(form => ({
                fresher: form.fresher,
            }));
            formData.append("employmentdata", JSON.stringify(employmentdata));
        } else {
            const fresherEmploymentData = [{
                fresher: "fresher"
            }];
            formData.append("employmentdata", JSON.stringify(fresherEmploymentData));
        }

        console.log("1Submitting form data...");
        for (let [key, value] of formData.entries()) {
            console.log(`${key}:`, value);
        }

        try {
            const response = await fetch("https://humhai.in/background-verification/newform/", {
                method: "POST",
                body: formData
            });

            const data = await response.json();


            console.log(data, "data")
            setCandidateId(data.id);

            if (data.status === 200) {
                alert("Your form has been successfully submitted.");
                setIsLoading(false);
                window.location.reload();
            } else {
                alert("Something went wrong. Please try again.");
                setIsLoading(false);
            }
        } catch (error) {
            console.error("Error:", error);
            alert("There was an error submitting the form.");
            setIsLoading(false);
        } finally {
            setIsLoading(false);
            document.querySelectorAll('input, select, textarea, button').forEach(element => {
                element.disabled = false;
            });
        }
    };

    return (
        <div className="form-container">
            {/* Header Section */}
            <div className="form-header">
                {steps.map((heading, index) => (
                    <div
                        key={index}
                        className={`step-title ${step === index + 1 ? "active" : "blurred"}`}
                    >
                        {heading}

                    </div>
                ))}
            </div>
            {/* Form Content */}
            <div className="form-content">
                {step === 1 && <div>

                    <div className="bg-light p-3 rounded-lg border border-opacity-50 mx-auto p-1">
                        <h2 className="text-center font-bold text-3xl mb-3">
                            CANDIDATE{" "}
                            <span className="text-orange-600">PERSONAL DETAILS</span>
                        </h2>
                        <hr />
                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="name_of_applicant" className="form-label">
                                    Name of the Applicant
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.name ? 'is-invalid' : ''}`}
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    name="name_of_applicant"
                                    required
                                />
                                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input2" className="form-label">
                                    Fathers/Husband/Wife Name
                                </label>
                                <input
                                    className={`inputtype form-control mb-3 ${errors.fname ? 'is-invalid' : ''}`}
                                    list="projects"
                                    value={fname}
                                    onChange={(e) => setFname(e.target.value)}
                                    name="fathers_name"
                                    maxLength="100"
                                    required
                                />
                                {errors.fname && <div className="invalid-feedback">{errors.fname}</div>}
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input3" className="form-label">
                                    Mother's Name
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.mname ? 'is-invalid' : ''}`}
                                    value={mname}
                                    onChange={(e) => setMname(e.target.value)}
                                    name="mothers_name"
                                    maxLength="100"
                                    required
                                />
                                {errors.mname && <div className="invalid-feedback">{errors.mname}</div>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input4" className="form-label">
                                    Applicant Gender
                                </label>{" "}
                                <select
                                    className={`inputtype form-control mb-3 ${errors.gender ? 'is-invalid' : ''}`}
                                    value={gender}
                                    onChange={(e) => setGender(e.target.value)}
                                    name="gender"
                                >
                                    <option value="">choose</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="other">other</option>
                                </select>
                                {errors.gender && <div className="invalid-feedback">{errors.gender}</div>}
                            </div>

                            <div className="col-md-4 input-icons">
                                <label htmlFor="Input5" className="form-label">
                                    Date Of Birth
                                </label>

                                <div className="date-container">
                                    <input
                                        value={date}
                                        onChange={(e) => setDate(e.target.value)}
                                        type="date"
                                        className={`inputtype form-control mb-3 ${errors.date ? 'is-invalid' : ''}`}
                                        name="dob"
                                        required
                                    />
                                    {errors.date && <div className="invalid-feedback">{errors.date}</div>}
                                </div>
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input6" className="form-label">
                                    Email Id
                                </label>{" "}

                                <input
                                    type="email"
                                    className={`inputtype form-control mb-3 ${errors.email ? 'is-invalid' : ''}`}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    name="email"
                                    required
                                />
                                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 input-icons">
                                <label htmlFor="Input5" className="form-label">
                                    Contact Number
                                </label>

                                <div className="date-container">
                                    <input
                                        type="number"
                                        className={`inputtype form-control mb-3 ${errors.number ? 'is-invalid' : ''}`}
                                        value={number}
                                        onChange={(e) => setNumber(e.target.value)}
                                        name="contact_number"
                                        required
                                    />
                                    {errors.number && <div className="invalid-feedback">{errors.number}</div>}
                                </div>
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input6" className="form-label">
                                    Emergency Contact
                                </label>

                                <input
                                    type="number"
                                    className={`inputtype form-control mb-3 ${errors.enumber ? 'is-invalid' : ''}`}
                                    value={enumber}
                                    onChange={(e) => setEnumber(e.target.value)}
                                    name="emergency_contact"
                                    required
                                />
                                {errors.enumber && <div className="invalid-feedback">{errors.enumber}</div>}
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Company Name
                                </label>

                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={companyname}
                                    onChange={(e) => setCompanyName(e.target.value)}
                                    name="name_of_client"
                                    maxLength="100"
                                    disabled
                                />
                            </div>

                        </div>

                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Company Location
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.location ? 'is-invalid' : ''}`}
                                    value={location}
                                    onChange={(e) => setLocation(e.target.value)}
                                    name="client_location"
                                    maxLength="30"
                                    required
                                />
                                {errors.location && <div className="invalid-feedback">{errors.location}</div>}
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Languages Known (optional)
                                </label>
                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={language}
                                    onChange={(e) => setLanguage(e.target.value)}
                                    name="languages"
                                    maxLength="30"
                                />
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Blood Group (optional)
                                </label>
                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={blood}
                                    onChange={(e) => setBlood(e.target.value)}
                                    name="blood_group"
                                    maxLength="5"
                                />
                            </div>
                        </div>

                        <div className="row">
                            <h2>Permanent Address</h2>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Address Line 1
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.address1 ? 'is-invalid' : ''}`}
                                    value={address1}
                                    onChange={(e) => setAddress1(e.target.value)}
                                    name="village_city"
                                    maxLength="25"
                                    required
                                />
                                {errors.address1 && <div className="invalid-feedback">{errors.address1}</div>}
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Address Line 2 (Optional)
                                </label>
                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={address2}
                                    onChange={(e) => setAddress2(e.target.value)}
                                    name="village_city2"
                                    maxLength="25"
                                />
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Address Line 3 (Optional)
                                </label>
                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={address3}
                                    onChange={(e) => setAddress3(e.target.value)}
                                    name="village_city3"
                                    maxLength="25"
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Name of Post Office
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.post ? 'is-invalid' : ''}`}
                                    value={post}
                                    onChange={(e) => setPost(e.target.value)}
                                    name="post_office"
                                    maxLength="100"
                                    required
                                />
                                {errors.post && <div className="invalid-feedback">{errors.post}</div>}
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Police Station/Thana
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.police ? 'is-invalid' : ''}`}
                                    value={police}
                                    onChange={(e) => setPolice(e.target.value)}
                                    name="police_station"
                                    maxLength="100"
                                    required
                                />
                                {errors.police && <div className="invalid-feedback">{errors.police}</div>}
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    District
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.district ? 'is-invalid' : ''}`}
                                    value={district}
                                    onChange={(e) => setDistrict(e.target.value)}
                                    name="district"
                                    maxLength="100"
                                    required
                                />
                                {errors.district && <div className="invalid-feedback">{errors.district}</div>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Tehsil
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.tehsil ? 'is-invalid' : ''}`}
                                    value={tehsil}
                                    onChange={(e) => setTehsil(e.target.value)}
                                    name="tehsil"
                                    maxLength="100"
                                    required
                                />
                                {errors.tehsil && <div className="invalid-feedback">{errors.tehsil}</div>}
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Landmark
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.landmark ? 'is-invalid' : ''}`}
                                    value={landmark}
                                    onChange={(e) => setLandmark(e.target.value)}
                                    name="landmark"
                                    maxLength="100"
                                    required
                                />
                                {errors.landmark && <div className="invalid-feedback">{errors.landmark}</div>}
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Pin Code
                                </label>
                                <input
                                    type="number"
                                    className={`inputtype form-control mb-3 ${errors.pincode ? 'is-invalid' : ''}`}
                                    value={pincode}
                                    onChange={(e) => setPincode(e.target.value)}
                                    name="pine_code"
                                    required
                                />
                                {errors.pincode && <div className="invalid-feedback">{errors.pincode}</div>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    State
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.state ? 'is-invalid' : ''}`}
                                    value={state}
                                    onChange={(e) => setState(e.target.value)}
                                    name="state"
                                    maxLength="20"
                                    required
                                />
                                {errors.state && <div className="invalid-feedback">{errors.state}</div>}
                            </div>
                        </div>

                        <div className="row mb-4 d-flex flex-row">
                            <label
                                style={{ width: "190px" }}
                                className="form-label"
                                htmlFor="same"
                            >
                                Same as above?
                            </label>
                            <input
                                style={{ width: "30px" }}
                                type="checkbox"
                                id="same"
                                name="same"
                                onChange={() => billingFunction()}
                            />
                        </div>

                        <div className="row">
                            <h2>Current Address</h2>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Address Line 1
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.address11 ? 'is-invalid' : ''}`}
                                    value={address11}
                                    onChange={(e) => setAddress11(e.target.value)}
                                    name="c_village_city"
                                    maxLength="25"
                                    required
                                />
                                {errors.address11 && <div className="invalid-feedback">{errors.address11}</div>}
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Address Line 2 (Optional)
                                </label>
                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={address22}
                                    onChange={(e) => setAddress22(e.target.value)}
                                    name="c_village_city2"
                                    maxLength="25"
                                />
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Address Line 3 (Optional)
                                </label>
                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={address33}
                                    onChange={(e) => setAddress33(e.target.value)}
                                    name="c_village_city3"
                                    maxLength="25"
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Name of Post Office
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.post1 ? 'is-invalid' : ''}`}
                                    value={post1}
                                    onChange={(e) => setPost1(e.target.value)}
                                    name="c_post_office"
                                    maxLength="100"
                                    required
                                />
                                {errors.post1 && <div className="invalid-feedback">{errors.post1}</div>}
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Police Station
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.police1 ? 'is-invalid' : ''}`}
                                    value={police1}
                                    onChange={(e) => setPolice1(e.target.value)}
                                    name="c_police_station"
                                    maxLength="100"
                                    required
                                />
                                {errors.police1 && <div className="invalid-feedback">{errors.police1}</div>}
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    District
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.district1 ? 'is-invalid' : ''}`}
                                    value={district1}
                                    onChange={(e) => setDistrict1(e.target.value)}
                                    name="c_district"
                                    maxLength="100"
                                    required
                                />
                                {errors.district1 && <div className="invalid-feedback">{errors.district1}</div>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Tehsil
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.tehsil1 ? 'is-invalid' : ''}`}
                                    value={tehsil1}
                                    onChange={(e) => setTehsil1(e.target.value)}
                                    name="c_tehsil"
                                    maxLength="100"
                                    required
                                />
                                {errors.tehsil1 && <div className="invalid-feedback">{errors.tehsil1}</div>}
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Landmark
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.landmark1 ? 'is-invalid' : ''}`}
                                    value={landmark1}
                                    onChange={(e) => setLandmark1(e.target.value)}
                                    name="c_landmark"
                                    maxLength="100"
                                    required
                                />
                                {errors.landmark1 && <div className="invalid-feedback">{errors.landmark1}</div>}
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    Pin Code
                                </label>
                                <input
                                    type="number"
                                    className={`inputtype form-control mb-3 ${errors.pincode1 ? 'is-invalid' : ''}`}
                                    value={pincode1}
                                    onChange={(e) => setPincode1(e.target.value)}
                                    name="c_pine_code"
                                    maxLength="100"
                                    required
                                />
                                {errors.pincode1 && <div className="invalid-feedback">{errors.pincode1}</div>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="Input7" className="form-label">
                                    State
                                </label>
                                <input
                                    type="text"
                                    className={`inputtype form-control mb-3 ${errors.state1 ? 'is-invalid' : ''}`}
                                    value={state1}
                                    onChange={(e) => setState1(e.target.value)}
                                    name="c_state"
                                    maxLength="20"
                                    required
                                />
                                {errors.state1 && <div className="invalid-feedback">{errors.state1}</div>}
                            </div>
                        </div>
                    </div>
                    <div style={{ overflow: "auto" }}>
                        <div style={{ float: "right" }}>
                            <button
                                type="button"
                                className="tablinks mb-2 ms-2"
                                onClick={nextStep1}
                            >
                                Next
                            </button>
                        </div>
                    </div>

                </div>}
                {step === 2 && <div>
                    <div className="bg-light rounded-3 p-2 mx-auto mb-3 border border-opacity-25">
                        <div className="text-center font-bold text-3xl">🎓 CANDIDATE <span style={{ color: "rgb(255, 119, 0)" }}>{" "}EDUCATION</span>{" "}DETAILS
                        </div>
                        <h5 className=" text-center" style={{ color: "rgb(255, 119, 0)" }}>
                            * Upload a Fully Clear and Completed Document *
                        </h5>
                        <hr />
                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="organisation">Institute Name</label>
                                <input
                                    type="text"
                                    value={institute}
                                    onChange={(e) => setInstitute(e.target.value)}
                                    name="institute_name"
                                    className={`inputtype form-control mb-3 ${errors.institute ? 'is-invalid' : ''}`}
                                    maxLength="100"
                                    required
                                />
                                {errors.institute && <div className="invalid-feedback">{errors.institute}</div>}
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="designation">Qualification</label>
                                <input
                                    type="text"
                                    value={qualification}
                                    onChange={(e) => setQualification(e.target.value)}
                                    name="qualification"
                                    className={`inputtype form-control mb-3 ${errors.qualification ? 'is-invalid' : ''}`}
                                    maxLength="100"
                                    required
                                />
                                {errors.qualification && <div className="invalid-feedback">{errors.qualification}</div>}
                            </div>
                            <div className="col-md-4 col-6">
                                <label htmlFor="organisation">Grades</label>
                                <input
                                    type="text"
                                    value={grade}
                                    onChange={(e) => setGrade(e.target.value)}
                                    name="grade_edu"
                                    className={`inputtype form-control mb-3 ${errors.grade ? 'is-invalid' : ''}`}
                                    maxLength="10"
                                    required
                                />
                                {errors.grade && <div className="invalid-feedback">{errors.grade}</div>}
                            </div>

                        </div>

                        <div className="row">
                            <div className="col-md-4 col-6">
                                <label htmlFor="organisation">From</label>
                                <input
                                    type="date"
                                    value={from_edu}
                                    onChange={(e) => setFrom_Edu(e.target.value)}
                                    name="from_edu"
                                    className={`inputtype form-control mb-3 ${errors.from_edu ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors.from_edu && <div className="invalid-feedback">{errors.from_edu}</div>}
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="designation">To</label>
                                <input
                                    type="date"
                                    value={to_edu}
                                    onChange={(e) => setTo_Edu(e.target.value)}
                                    name="to_edu"
                                    className={`inputtype form-control mb-3 ${errors.to_edu ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors.to_edu && <div className="invalid-feedback">{errors.to_edu}</div>}
                            </div>



                            <div className="col-md-4 col-6">
                                <label htmlFor="City">City</label>
                                <input
                                    type="text"
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                    name="city_edu"
                                    className={`inputtype form-control mb-3 ${errors.city ? 'is-invalid' : ''}`}
                                    maxLength="20"
                                    required
                                />
                                {errors.city && <div className="invalid-feedback">{errors.city}</div>}
                            </div>

                        </div>
                        <div className="row">

                            <div className="col-md-4 col-6">
                                <label htmlFor="10th Marksheet">10th Marksheet</label>
                                <span style={{ color: "red", fontSize: "small" }}>(use .jpg and .png format)</span>
                                <input
                                    type="file"
                                    onChange={(e) => handleFileChange(e, setMarksheet10)}
                                    accept=".png, .jpg"
                                    name="marksheet_10"
                                    className={`inputtype form-control mb-3 ${errors.marksheet10 ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors.marksheet10 && <div className="invalid-feedback">{errors.marksheet10}</div>}
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="12th Marksheet">12th Marksheet</label>
                                <span style={{ color: "red", fontSize: "small" }}>{" "}(use .jpg and .png format)</span>
                                <input
                                    type="file"
                                    onChange={(e) => handleFileChange(e, setMarksheet12)}
                                    name="marksheet_12"
                                    accept=".png, .jpg"
                                    className={`inputtype form-control mb-3 ${errors.marksheet12 ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors.marksheet12 && <div className="invalid-feedback">{errors.marksheet12}</div>}
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="10th Marksheet">Graduation/Post Graduation</label>
                                <select
                                    className={`inputtype form-control mb-3 ${errors.marksheet12 ? 'is-invalid' : ''}`}
                                    name="higher_education"
                                    value={graduation}
                                    onChange={(e) => setGraduation(e.target.value)}
                                >
                                    <option value="">Choose</option>
                                    <option value="BA">BA</option>
                                    <option value="B.COM">B.COM</option>
                                    <option value="BSc">BSc</option>
                                    <option value="MA">MA</option>
                                    <option value="MBA">MBA</option>
                                    <option value="B.TECH">B.TECH</option>
                                    <option value="M.TECH">M.TECH</option>
                                    <option value="M.COM">M.COM</option>
                                    <option value="M.Sc">M.Sc</option>
                                    <option value="other" id="otherprogram">
                                        Other program
                                    </option>
                                </select>

                                {errors.graduation && <div className="invalid-feedback">{errors.graduation}</div>}
                            </div>

                        </div>

                        <div className="row">

                            <div className="col-md-4 col-6">
                                <label htmlFor="12th Marksheet">
                                    Graduation/Post Graduation Marksheet
                                </label>
                                <span style={{ color: "red", fontSize: "small" }}>{" "}(use .jpg and .png format)</span>
                                <input
                                    type="file"
                                    onChange={(e) =>
                                        handleFileChange(e, setGraduation_Marksheet)
                                    }
                                    accept=".png, .jpg"
                                    name="higher_education_marksheet"
                                    className={`inputtype form-control mb-3 ${errors.graduation_marksheet ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors.graduation_marksheet && <div className="invalid-feedback">{errors.graduation_marksheet}</div>}
                            </div>

                            <div className="col-md-4 col-6">
                                <label htmlFor="12th Marksheet">Graduation/Post Graduation Degree/Provisional Degree</label>
                                <span style={{ color: "red", fontSize: "small" }}>{" "}(use .jpg and .png format)</span>
                                <input
                                    type="file"
                                    onChange={(e) => handleFileChange(e, setProvisional_Degree)}
                                    name="higher_education_degree_provisional"
                                    accept=".png, .jpg"
                                    className={`inputtype form-control mb-3 ${errors.provisional_degree ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors.provisional_degree && <div className="invalid-feedback">{errors.provisional_degree}</div>}
                            </div>
                        </div>

                    </div>
                    <div style={{ overflow: "auto" }}>
                        <div style={{ float: "right" }}>
                            <button
                                type="button"
                                style={{ backgroundColor: "#BBBBBB" }}
                                className="tablinks mb-2 ms-2"
                                onClick={prevStep}
                            >
                                Previous
                            </button>
                            <button
                                type="button"
                                className="tablinks mb-2 ms-2"
                                onClick={nextStep2}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>}

                {step === 3 && <div>
                    <div className="bg-light p-3 rounded-3 p-3 mx-auto border border-opacity-50">
                        <div className="text-center font-bold text-3xl">🤝 CANDIDATE<span style={{ color: "rgb(255, 119, 0)" }}>{" "}
                            REFERENCES</span>{" "}DETAILS
                        </div>
                        <h5 className=" text-center" style={{ color: "rgb(255, 119, 0)" }}>* Duplicate contact numbers are not allowed. *</h5>
                        <hr />
                        <div className="ref1 mb-4 text-center">
                            <h4 style={{ color: "rgb(255, 119, 0)" }}>Add Reference 1</h4>
                            <h5>Please provide references from your family or close relatives only.</h5>
                        </div>
                        <hr className="ms-5 me-5 mb-4" />
                        <div className="row">
                            <div className="col-md-6">
                                <label htmlFor="Input13" className="form-label">
                                    Name
                                </label>
                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={reference_1_name}
                                    onChange={(e) => setReference_1_Name(e.target.value)}
                                    name="ref_name1"
                                    maxLength="100"
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="Input14" className="form-label">
                                    Relation
                                </label>
                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={reference_1_relation}
                                    onChange={(e) => setReference_1_Relation(e.target.value)}
                                    name="ref_relation1"
                                    maxLength="100"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <label htmlFor="Input15" className="form-label">
                                    Contact No.
                                </label>
                                <input
                                    type="number"
                                      className={`inputtype form-control mb-3 ${errors.name ? 'is-invalid' : ''}`}
                                    value={reference_1_number}
                                    onChange={(e) => setReference_1_Number(e.target.value)}
                                    name="ref_conatact1"
                                />
                                {errors.reference_1_number && (
                                    <div className="text-danger">
                                        {errors.reference_1_number}
                                    </div>
                                )}
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="Input13" className="form-label">
                                    Address
                                </label>
                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={reference_1_address}
                                    onChange={(e) => setReference_1_Address(e.target.value)}
                                    name="ref_address1"
                                    maxLength="100"
                                />
                            </div>
                        </div>

                        <hr className="ms-5 me-5" />
                        <div className="ref2 mb-4 text-center">
                            <h4 style={{ color: "rgb(255, 119, 0)" }}>Add Reference 2</h4>
                            <h5>Please provide references from your family or close relatives only.</h5>
                        </div>
                        <hr className="ms-5 me-5 mb-4" />
                        <div className="row">
                            <div className="col-md-6">
                                <label htmlFor="Input13" className="form-label">
                                    Name
                                </label>{" "}

                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={reference_2_name}
                                    onChange={(e) => setReference_2_Name(e.target.value)}
                                    name="ref_name2"
                                    maxLength="100"
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="Input14" className="form-label">
                                    Relation
                                </label>{" "}

                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={reference_2_relation}
                                    onChange={(e) => setReference_2_Relation(e.target.value)}
                                    name="ref_relation2"
                                    maxLength="100"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <label htmlFor="Input15" className="form-label">
                                    Contact No.
                                </label>

                                <input
                                    type="number"
                                      className={`inputtype form-control mb-3 ${errors.name ? 'is-invalid' : ''}`}
                                    value={reference_2_number}
                                    onChange={(e) => setReference_2_Number(e.target.value)}
                                    name="ref_contact2"
                                />
                                {errors.reference_2_number && (
                                    <div className="text-danger">
                                        {errors.reference_2_number}
                                    </div>
                                )}
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="Input13" className="form-label">
                                    Address
                                </label>{" "}

                                <input
                                    type="text"
                                    className="inputtype form-control mb-3"
                                    value={reference_2_address}
                                    onChange={(e) => setReference_2_Address(e.target.value)}
                                    name="ref_address2"
                                    maxLength="100"
                                />
                            </div>
                        </div>
                        <hr className="ms-5 me-5" />
                       
                       
                    </div>
                    <div style={{ overflow: "auto" }}>
                        <div style={{ float: "right" }}>
                            <button
                                type="button"
                                className="tablinks mb-2 ms-2"
                                style={{ backgroundColor: "#BBBBBB" }}
                                onClick={prevStep}
                            >
                                Previous
                            </button>
                            <button
                                type="button"
                                className="tablinks mb-2 ms-2"
                                onClick={nextStep3}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>}

                {step === 4 && <div>
                    <div className="bg-light p-3 rounded-3 p-3 mx-auto border border-opacity-50">
                        <div className="text-center font-bold text-3xl" >📄 CANDIDATE
                            <span style={{ color: "rgb(255, 119, 0)" }}>{" "}DOCUMENTS{" "}</span>{" "}DETAILS
                        </div>
                        <h5 className=" text-center" style={{ color: "rgb(255, 119, 0)" }}>
                            * Upload a Fully Clear and Completed Document *
                        </h5>
                        <h4 style={{ color: "red", textAlign: "center" }}>* use .jpg and .png format * </h4>
                        <hr />
                        <div className="row">
                            <div className="col-md-4">
                                <label htmlFor="Input7" className="form-label">Aadhar Card Number</label>
                                <input
                                    type="text"
                                    value={aadhar}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, '').slice(0, 12);
                                        setAadhar(value);
                                        if (errors.aadhar && value.length === 12) {
                                            setErrors({ ...errors, aadhar: '' });
                                        }
                                    }}
                                    name="aadhar_card"
                                    className={`inputtype form-control mb-3 ${errors.aadhar ? 'is-invalid' : ''}`}
                                    inputMode="numeric"
                                    pattern="\d{12}"
                                    maxLength="12"
                                    placeholder="Enter 12-digit Aadhar number"
                                    required
                                />
                                {errors.aadhar && (
                                    <div className="invalid-feedback">
                                        {errors.aadhar === "Aadhar Number is required"
                                            ? "Aadhar Number is required"
                                            : "Aadhar must be exactly 12 digits (numbers only)"}
                                    </div>
                                )}
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="Input8" className="form-label">Aadhar Card FRONT SIDE</label>
                                <input
                                    type="file"
                                    onChange={(e) =>
                                        handleFileChange(e, setAadhar_Front_Side)
                                    }
                                    accept=".png, .jpg"
                                    name="aadhar_front"
                                    className={`inputtype form-control mb-3 ${errors.aadhar_front_side ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors.aadhar_front_side && <div className="invalid-feedback">{errors.aadhar_front_side}</div>}
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="Input9" className="form-label">Aadhar Card BACK SIDE</label>
                                <input
                                    type="file"
                                    onChange={(e) => handleFileChange(e, setAadhar_Back_Side)}
                                    name="aadhar_back"
                                    accept=".png, .jpg"
                                    className={`inputtype form-control mb-3 ${errors.aadhar_back_side ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors.aadhar_back_side && <div className="invalid-feedback">{errors.aadhar_back_side}</div>}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <label htmlFor="Input9" className="form-label">Passport Size Photo</label>
                                <input
                                    type="file"
                                    onChange={(e) =>
                                        handleFileChange(e, setPassport_Size_Photo)
                                    }
                                    name="passport_photo"
                                    accept=".png, .jpg"
                                    className={`inputtype form-control mb-3 ${errors.passport_size_photo ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors.passport_size_photo && <div className="invalid-feedback">{errors.passport_size_photo}</div>}
                            </div>
                             <div className="col-md-4">
                                <label htmlFor="Input9" className="form-label">Pan Card</label>
                                <input
                                    type="file"
                                    onChange={(e) =>
                                        handleFileChange(e, setPancard)
                                    }
                                    name="pan_card"
                                    accept=".png, .jpg"
                                    className={`inputtype form-control mb-3 ${errors.pan_card ? 'is-invalid' : ''}`}
                                    required
                                />
                                {errors.pan_card && <div className="invalid-feedback">{errors.pan_card}</div>}
                            </div>

                        </div>
                       
                    </div>
                    <div style={{ overflow: "auto" }}>
                        <div style={{ float: "right" }}>
                            <button
                                type="button"
                                className="tablinks mb-2 ms-2"
                                style={{ backgroundColor: "#BBBBBB" }}
                                onClick={prevStep}
                            >
                                Previous
                            </button>
                            <button
                                type="button"
                                className="tablinks mb-2 ms-2"
                                onClick={nextStep4}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>}

                {step === 5 && <div>
                    <div className="bg-light p-3 rounded-3 p-3 mx-auto border border-opacity-50">
                        <div className="text-center font-bold text-3xl mb-3">🏠 CANDIDATE<span style={{ color: "rgb(255, 119, 0)" }}>{' '}TENANCY</span>{" "}
                            DETAILS
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-md-4 col-sm-6">
                                <label>Tenancy</label>

                                <select
                                    className="form-control mt-3"
                                    name="choose_tenancy"
                                    id="tenancy1"
                                    onChange={() => {
                                        hideTenancy();
                                        setHouse_Owner_Name("");
                                        setTenancy_Address("");
                                        setTenancy_Number("");
                                        setResiding_date("");
                                    }}
                                >
                                    <option value="">Choose</option>
                                    <option value="Own House">Own House</option>
                                    <option value="Rented">Rented</option>
                                </select>
                            </div>
                        </div>
                        {isOwnHouse ? (
                            <div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="form-label">House Owner Name</label>

                                        <input
                                            type="text"
                                            className="inputtype form-control mb-3"
                                            value={house_owner_name}
                                            onChange={(e) => setHouse_Owner_Name(e.target.value)}
                                            name="house_owner_name"
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Address</label>
                                        <input
                                            type="text"
                                            className="inputtype form-control mb-3"
                                            value={tenancy_address}
                                            onChange={(e) => setTenancy_Address(e.target.value)}
                                            name="tenancy_address"
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="form-label">Contact Number</label>

                                        <input
                                            type="number"
                                            className="inputtype form-control mb-3"
                                            value={tenancy_number}
                                            onChange={(e) => setTenancy_Number(e.target.value)}
                                            name="tenancy_number"
                                        />
                                    </div>
                                    <div className="col-md-6 input-icons">
                                        <label className="form-label">Residing Date</label>

                                        <div className="date-container">
                                            <input
                                                value={residing_date}
                                                onChange={(e) => setResiding_date(e.target.value)}
                                                name="residing_date"
                                                type="date"
                                                className="inputtype form-control mb-3"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                    <div style={{ overflow: "auto" }}>
                        <div style={{ float: "right" }}>
                            <button
                                type="button"
                                className="tablinks mb-2 ms-2"
                                style={{ backgroundColor: "#BBBBBB" }}
                                onClick={prevStep}
                                disabled={isLoading}
                            >
                                Previous
                            </button>
                            <button
                                className="tablinks mb-2 ms-2"
                                onClick={nextStep5}
                                disabled={isLoading}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>}

                {step === 6 && <div>
                    <div className="bg-light rounded-3 p-2 mx-auto mb-3 border border-opacity-25">
                        <div className="text-center font-bold text-3xl mb-3">💼 CANDIDATE<span style={{ color: "rgb(255, 119, 0)" }}>{" "}PREVIOUS EMPLOYEMENT</span>{" "}DETAILS
                        </div>
                        <hr />
                        <div className="col-md-4 col-sm-6">
                            <label>Employment Choose</label>
                            <select
                                className="form-control mt-3"
                                name="choose_tenancy"
                                id="employment1"
                                onChange={hideEmployment}
                                required
                            >
                                <option value="">Choose</option>
                                <option value="Fresher">Fresher</option>
                                <option value="Experience">Experience</option>
                            </select>
                            <div className="row ms-4 mb-4">
                                {isLoading ? (
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            zIndex: "1",
                                            flexDirection: "column",
                                        }}
                                    >
                                        {" "}
                                        <img src={img} alt="" />
                                        <div
                                            style={{
                                                color: "#DE3500",
                                                marginTop: "10px",
                                            }}
                                        >
                                            Please Wait ......
                                        </div>
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                        {/* {selectExperience ? ( */}
                        {selectExperience && (
                            <div>
                                {Array.isArray(formValues) &&
                                    formValues.map((element, index) => (
                                        <div
                                            className="form-inline"
                                            key={index}
                                            disabled={index !== formValues.length - 1}
                                        >
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h5>Employment #{index + 1}</h5>
                                                {formValues.length > 1 && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => {
                                                            if (window.confirm("Are you sure you want to remove this employment entry?")) {
                                                                removeFormFields(index);
                                                            }
                                                        }}
                                                        disabled={isLoading}
                                                    >
                                                        Remove
                                                    </button>
                                                )}
                                            </div>
                                            <div>
                                                <div className="row">
                                                    <div className="col-md-4 col-6">
                                                        <label htmlFor="organisation">Company Name</label>
                                                        <input
                                                            type="text"
                                                            value={element.previous_company_name || ""}
                                                            onChange={(e) => handleChange(index, e)}
                                                            name="previous_company_name"
                                                            className="inputtype form-control mb-3"
                                                            maxLength="100"
                                                            disabled={index !== formValues.length - 1}
                                                            required
                                                        />
                                                    </div>

                                                    <div className="col-md-4 col-6">
                                                        <label htmlFor="designation">Designation</label>

                                                        <input
                                                            type="text"
                                                            value={element.previous_designation || ""}
                                                            onChange={(e) => handleChange(index, e)}
                                                            name="previous_designation"
                                                            className="inputtype form-control mb-3"
                                                            maxLength="100"
                                                            disabled={index !== formValues.length - 1}
                                                            required
                                                        />
                                                    </div>

                                                    <div className="col-md-4 col-6">
                                                        <label htmlFor="Employee_id">Employee Id</label>

                                                        <input
                                                            type="text"
                                                            value={element.Employee_id || ""}
                                                            onChange={(e) => handleChange(index, e)}
                                                            name="Employee_id"
                                                            className="inputtype form-control mb-3"
                                                            maxLength="100"
                                                            disabled={index !== formValues.length - 1}
                                                            required
                                                        />
                                                    </div>

                                                </div>

                                                <div className="row">
                                                    <div className="col-md-4 col-6">
                                                        <label htmlFor="hr_name">HR Name</label>
                                                        <input
                                                            type="text"
                                                            value={element.hr_name || ""}
                                                            onChange={(e) => handleChange(index, e)}
                                                            name="hr_name"
                                                            className="inputtype form-control mb-3"
                                                            maxLength="100"
                                                            disabled={index !== formValues.length - 1}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="col-md-4 col-6">
                                                        <label htmlFor="Hr_number">HR Contact Number</label>
                                                        <input
                                                            type="number"
                                                            value={element.Hr_number || ""}
                                                            onChange={(e) => handleChange(index, e)}
                                                            name="Hr_number"
                                                            className="inputtype form-control mb-3"
                                                            disabled={index !== formValues.length - 1}
                                                            required
                                                        />
                                                    </div>

                                                    <div className="col-md-4 col-6">
                                                        <label htmlFor="Hr_email_id">HR Email Id</label>

                                                        <input
                                                            type="email"
                                                            value={element.Hr_email_id || ""}
                                                            onChange={(e) => handleChange(index, e)}
                                                            name="Hr_email_id"
                                                            className="inputtype form-control mb-3"
                                                            disabled={index !== formValues.length - 1}
                                                            required
                                                        />
                                                    </div>

                                                </div>

                                                <div className="row">
                                                    <div className="col-md-4 col-6">
                                                        <label htmlFor="previous_salary">Annual CTC *</label>
                                                        <input
                                                            type="number"
                                                            value={element.previous_salary || ""}
                                                            onChange={(e) => handleChange(index, e)}
                                                            name="previous_salary"
                                                            className="inputtype form-control mb-3"
                                                            disabled={index !== formValues.length - 1}
                                                            required
                                                        />
                                                        {error && <p style={{ color: "red" }}>{error}</p>}
                                                    </div>

                                                    <div className="col-md-4 col-6">
                                                        <label htmlFor="reason_of_leaving">
                                                            Reason of leaving
                                                        </label>
                                                        <input
                                                            type="text"
                                                            value={element.reason_of_leaving || ""}
                                                            onChange={(e) => handleChange(index, e)}
                                                            name="reason_of_leaving"
                                                            className="inputtype form-control mb-3"
                                                            maxLength="255"
                                                            disabled={index !== formValues.length - 1}
                                                            required
                                                        />
                                                    </div>


                                                    <div className="col-md-4 col-6">
                                                        <label htmlFor="designation">
                                                            Work Responsibility
                                                        </label>
                                                        <input
                                                            type="text"
                                                            value={element.work_reponsibility || ""}
                                                            onChange={(e) => handleChange(index, e)}
                                                            name="work_reponsibility"
                                                            className="inputtype form-control mb-3"
                                                            maxLength="100"
                                                            disabled={index !== formValues.length - 1}
                                                            required
                                                        />
                                                    </div>
                                                </div>


                                            </div>

                                            <div className="row">
                                                <div className="col-md-4 col-6">
                                                    <label htmlFor="previous_manager">
                                                        Supervisor/Manager Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        value={element.previous_manager || ""}
                                                        onChange={(e) => handleChange(index, e)}
                                                        name="previous_manager"
                                                        className="inputtype form-control mb-3"
                                                        maxLength="100"
                                                        disabled={index !== formValues.length - 1}
                                                        required
                                                    />
                                                </div>

                                                <div className="col-md-4 col-6">
                                                    <label htmlFor="previous_manager_number">
                                                        Supervisor/Manager Number *
                                                    </label>

                                                    <input
                                                        type="number"
                                                        value={element.previous_manager_number || ""}
                                                        onChange={(e) => handleChange(index, e)}
                                                        name="previous_manager_number"
                                                        className="inputtype form-control mb-3"
                                                        maxLength="255"
                                                        disabled={index !== formValues.length - 1}
                                                        required
                                                    />
                                                </div>

                                                <div className="col-md-4 col-6">
                                                    <label htmlFor="previous_manager_email_id">
                                                        Supervisor/Manager Email Id *
                                                    </label>
                                                    <input
                                                        type="email"
                                                        value={element.previous_manager_email_id || ""}
                                                        onChange={(e) => handleChange(index, e)}
                                                        name="previous_manager_email_id"
                                                        className="inputtype form-control mb-3"
                                                        maxLength="100"
                                                        disabled={index !== formValues.length - 1}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-4 col-6">
                                                    <label htmlFor="from_previous_company">
                                                        From
                                                    </label>

                                                    <input
                                                        type="date"
                                                        value={element.from_previous_company || ""}
                                                        onChange={(e) => handleChange(index, e)}
                                                        name="from_previous_company"
                                                        className="inputtype form-control mb-3"
                                                        disabled={index !== formValues.length - 1}
                                                        required
                                                    />
                                                </div>
                                                <div className="col-md-4 col-6">
                                                    <label htmlFor="to_previous_company">To</label>

                                                    <input
                                                        type="date"
                                                        value={element.to_previous_company || ""}
                                                        onChange={(e) => handleChange(index, e)}
                                                        name="to_previous_company"
                                                        className="inputtype form-control mb-3"
                                                        disabled={index !== formValues.length - 1}
                                                        required
                                                    />
                                                </div>
                                                <div className="col-md-4 col-6">
                                                    <label htmlFor="organisation">Location</label>
                                                    <input
                                                        type="text"
                                                        value={element.location || ""}
                                                        onChange={(e) => handleChange(index, e)}
                                                        name="location"
                                                        className="inputtype form-control mb-3"
                                                        maxLength="100"
                                                        disabled={index !== formValues.length - 1}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-4 col-6">
                                                    <label htmlFor="payslip">Pay Slip 1</label>
                                                    <span style={{ color: "red", fontSize: "small" }}>
                                                        {" "}
                                                        (use .jpg and .png format)
                                                    </span>

                                                    <input
                                                        type="file"
                                                        name="payslip"
                                                        onChange={(e) =>
                                                            handleFileChange1(e, index, "payslip")
                                                        }
                                                        className="inputtype form-control mb-3"
                                                        disabled={index !== formValues.length - 1}
                                                        accept=".png, .jpg"
                                                        required
                                                    />
                                                </div>
                                                <div className="col-md-4 col-6">
                                                    <label htmlFor="pay_slip2">Pay Slip 2</label>
                                                    <span style={{ color: "red", fontSize: "small" }}>
                                                        {" "}
                                                        (use .jpg and .png format)
                                                    </span>

                                                    <input
                                                        type="file"
                                                        name="pay_slip2"
                                                        accept=".png, .jpg"
                                                        onChange={(e) =>
                                                            handleFileChange1(e, index, "pay_slip2")
                                                        }
                                                        className="inputtype form-control mb-3"
                                                        disabled={index !== formValues.length - 1}
                                                        required
                                                    />
                                                </div>

                                                <div className="col-md-4 col-6">
                                                    <label htmlFor="pay_slip3">Pay Slip 3</label>
                                                    <span style={{ color: "red", fontSize: "small" }}>
                                                        {" "}
                                                        (use .jpg and .png format)
                                                    </span>

                                                    <input
                                                        type="file"
                                                        name="pay_slip3"
                                                        accept=".png, .jpg"
                                                        onChange={(e) =>
                                                            handleFileChange1(e, index, "pay_slip3")
                                                        }
                                                        className="inputtype form-control mb-3"
                                                        disabled={index !== formValues.length - 1}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-4 col-6">
                                                    <label htmlFor="offer_latter">Offer Letter</label>
                                                    <span style={{ color: "red", fontSize: "small" }}>
                                                        {" "}
                                                        (use .jpg and .png format)
                                                    </span>

                                                    <input
                                                        type="file"
                                                        name="offer_letter"
                                                        accept=".png, .jpg"
                                                        onChange={(e) =>
                                                            handleFileChange1(e, index, "offer_letter")
                                                        }
                                                        className="inputtype form-control mb-3"
                                                        disabled={index !== formValues.length - 1}
                                                        required
                                                    />
                                                </div>
                                                <div className="col-md-4 col-6">
                                                    <label htmlFor="resignation_latter">
                                                        Resignation Letter
                                                    </label>
                                                    <span style={{ color: "red", fontSize: "small" }}>
                                                        {" "}
                                                        (use .jpg and .png format)
                                                    </span>

                                                    <input
                                                        type="file"
                                                        name="resignation"
                                                        accept=".png, .jpg"
                                                        onChange={(e) =>
                                                            handleFileChange1(e, index, "resignation")
                                                        }
                                                        className="inputtype form-control mb-3"
                                                        disabled={index !== formValues.length - 1}
                                                        required
                                                    />
                                                </div>
                                                <div className="col-md-4 col-6"        >
                                                    <label htmlFor="resignation_latter">
                                                        Experience Letter
                                                    </label>
                                                    <span style={{ color: "red", fontSize: "small" }}>
                                                        {" "}
                                                        (use .jpg and .png format)
                                                    </span>

                                                    <input
                                                        type="file"
                                                        name="experience_letter"
                                                        accept=".png, .jpg"
                                                        onChange={(e) =>
                                                            handleFileChange1(
                                                                e,
                                                                index,
                                                                "experience_letter"
                                                            )
                                                        }
                                                        className="inputtype form-control mb-3"
                                                        disabled={index !== formValues.length - 1}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="row ms-4 mb-4">
                                                {isLoading ? (
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            zIndex: "1",
                                                            flexDirection: "column",
                                                        }}
                                                    >
                                                        {" "}
                                                        <img src={img} alt="" />
                                                        <div
                                                            style={{
                                                                color: "#DE3500",
                                                                marginTop: "10px",
                                                            }}
                                                        >
                                                            Please Wait ......
                                                        </div>
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        </div>
                                    ))}

                                <div className="button-section">
                                    <button
                                        type="button"
                                        className="tablinks mb-2 ms-2"
                                        style={{ backgroundColor: "#BBBBBB" }}
                                        onClick={prevStep}
                                        disabled={isLoading}
                                    >
                                        Previous
                                    </button>
                                    <div style={{ overflow: "auto" }}>
                                        <div style={{ float: "right" }}>
                                            <button
                                                type="button"
                                                className="tablinks mb-2 ms-2"
                                                style={{
                                                    backgroundColor: "green",
                                                    color: "white",
                                                    padding: "8px 16px",
                                                    borderRadius: "4px",
                                                    border: "none",
                                                    cursor: "pointer",
                                                    transition: "background-color 0.3s"
                                                }}
                                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = "darkgreen"}
                                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = "green"}
                                                onClick={addFormFields}
                                                disabled={isLoading}
                                            >
                                                Add +
                                            </button>
                                            <button
                                                type="submit"
                                                className="tablinks mb-2 ms-2"
                                                onClick={(e) => BgcFormSubmit(e)}
                                                disabled={isLoading}
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>}
 
            </div>
        </div>
    );
};
export default BgcForm;
